<template>
  <div class="customize-tree">
    <el-tree
      :ref="customizeTreeRef"
      :data="customizeTreeArr"
      :show-checkbox="showCheckbox"
      node-key="id"
      :render-after-expand="false"
      :default-checked-keys="defaultCustomizeTreeCheckedKeys"
      @check-change="caseCheckChange"
      @node-click="onNodeClick"
      :props="defaultCustomizeTreeProps">
      <template slot-scope="{ node, data }" v-if="openExitCustomizeLabel">
        <span class="customize-label">
          <el-tooltip
            :ref="`enterWarehosCodeRef${data.label}tip`"
            :content="data.label"
            placement="top"
            :disabled="showTooltip"
          >
            <div
              class="tips"
              @mouseover="onMouseOver(`enterWarehosCodeRef${data.label}`)"
            >
              <span :ref="`enterWarehosCodeRef${data.label}`">{{ data.label }}</span>
            </div>
          </el-tooltip>
          <span class="currency-info" v-if="data.level === 1">
            <img class="currency-img" :src="imgUrl">
            <span>{{ data.amount }}</span>
          </span>
        </span>
      </template>
    </el-tree>
  </div>
</template>

<script>
export default {
  props: {
    // 数据
    customizeTreeArr: {
      type: Array,
      default() {
        return []
      }
    },
    imgUrl: {
      type: String
    },
    openExitCustomizeLabel: {
      type: Boolean,
      default: false
    },
    // 默认选中的节点数据
    defaultCustomizeTreeCheckedKeys: {
      type: Array,
      default() {
        return []
      }
    },
    defaultCustomizeTreeProps: {
      type: Object,
      default() {
        return {
          children: 'children',
          label: 'label'
        }
      }
    },
    // 是否展示勾选框
    showCheckbox: {
      type: Boolean,
      default: false
    },
    customizeTreeRef: {
      type: String,
      default: 'customizeTreeRef'
    }
  },

  data() {
    return {
      showTooltip: false,
    }
  },

  created() {
    this.$bus.on('onGetChecked', v => {
      // 全选
      if (v) {
        this.$refs[this.customizeTreeRef].setCheckedNodes(this.customizeTreeArr)
      } else {
        this.$refs[this.customizeTreeRef].setCheckedNodes([])
      }
    })
  },

  methods: {
    caseCheckChange(data, checked, indeterminate) {
      let checkedKeysArr = this.$refs[this.customizeTreeRef].getCheckedKeys()
      let checkedCount = checkedKeysArr.length
      let allArr = this.convertTreeData(this.customizeTreeArr)
      this.$emit('onGetCheckedAll', checkedCount === allArr.length, checkedCount > 0 && checkedCount < allArr.length, data, checked, indeterminate)
    },

    onNodeClick(data, node) {
      if (node.level > 1) {
        this.$refs[this.customizeTreeRef].setChecked(data.id, !node.checked, true)
        this.$emit('onGetNodeData', data, node)
      }
    },


    // tree 结构转化成一维数组
    convertTreeData(menuOptions) {
      for (let i = 0; i < menuOptions.length; i++) {
        if (menuOptions[i].children != undefined) {
          const temp = menuOptions[i].children
          menuOptions = menuOptions.concat(temp)
        }
      }
      return menuOptions
    },

    
    onMouseOver(refName) {
      this.showTooltip = false
      const node = this.$refs[refName]
      const parentWidth = node.parentNode.offsetWidth
      const contentWidth = node.offsetWidth
      this.showTooltip = contentWidth <= parentWidth
    }
  }
}
</script>

<style lang='scss'>
.customize-tree {
  .el-tree {
    .el-tree-node {
      position: relative;
      .el-tree-node__content {
        background: none;
        .el-icon-caret-right.expanded {
          transform: none;
        }
        // 有子节点且未展开
        .el-icon-caret-right::before {
          background: url('~assets/images/add.png') no-repeat;
          content: '';
          display: block;
          width: 12px;
          height: 12px;
          background-size: 12px;
        }
        // 有子节点且已展开
        .el-icon-caret-right.expanded::before {
          background: url('~assets/images/minus.png') no-repeat;
          content: '';
          display: block;
          width: 12px;
          height: 12px;
          background-size: 12px;
        }
        // 没有子节点
        .el-icon-caret-right.is-leaf::before {
          background: transparent;
          content: '';
          display: block;
          width: 12px;
          height: 12px;
          background-size: 12px;
        }
        .el-tree-node__label {
          text-overflow: ellipsis;
          overflow: hidden;
          white-space: nowrap;
          font-size: 14px;
          color: #666666;
        }
      }
      .el-tree-node__content:hover {
        background: none;
      }
      .el-tree-node__children {
        .el-tree-node {
          .el-tree-node__content {
            height: 26px;
            padding-left: 0px !important;
            .el-tree-node__label {
              color: #666;
            }
          }
        }
        .el-tree-node.is-current {
          .el-tree-node__content {
            .el-tree-node__label {
              color: #2E68EA;
            }
          }
        }
        // 竖线
        .el-tree-node::before {
          content: '';
          position: absolute;
          width: 1px;
          height: 100%;
          left: 12px;
          top: 0px;
          border-width: 1px;
          border-left: 1px solid #eee;
        }
      }
      
      .el-tree-node__content {
        align-items: flex-start;
        height: 60px;
        .el-checkbox {
          margin-top: 4px;
        }
      }
      .customize-label {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        margin-top: 4px;
      }
      .currency-info {
        min-width: 50px;
        padding: 4px;
        background: #F9F9F9;
        border-radius: 4px;
        float: left;
        margin-top: 4px;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        .currency-img {
          width: 16px;
          height: 16px;
          margin-right: 2px;
        }
        span {
          font-size: 14px;
          line-height: 14px;
          color: #666666;
          font-family: 'PingFang SC-Regular';
          font-weight: 400;
        }
      }
    }
    
    .tips {
      width: 144px;
      color: #666666;
      font-size: 14px;
      cursor: pointer;
      margin-left: 3px;
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
    }
    
    .el-tree-node.is-expanded {
      .el-tree-node__content {
        &::before {
          content: '';
          position: absolute;
          width: 1px;
          height: 40px;
          left: 12px;
          top: 20px;
          border-width: 1px;
          border-left: 1px solid #eee;
        }
      }
    }
    // .el-tree-node.is-current {
    //   .el-tree-node__content {
    //     .el-tree-node__label {
    //       color: #2E68EA;
    //     }
    //   }
    // }
  }
  
  .el-tree .el-tree-node:nth-last-child(2) {
    .el-tree-node__content {
      &::before {
        display: none;
      }
    }
    .el-tree-node__children {
      // 竖线
      .el-tree-node::before {
        display: none;
      }
    }
  }
}
</style>
